"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      visible: false,
      skuItems: []
    };
  },
  mounted: function mounted() {},
  methods: {
    initOpen: function initOpen(skuItems) {
      this.skuItems = skuItems || [];
      this.visible = true;
    }
  }
};